import React, { useEffect, useRef, useState } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './FeaturedServices.css';

function FeaturedServices() {
    const [inView, setInView] = useState(false);
    const sectionRef = useRef();

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setInView(true);
                }
            },
            { threshold: 0.3 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => observer.disconnect();
    }, []);

    const services = [
        {
            id: 1,
            title: "Odoo ERP",
            subtitle: "Sviluppo e Manutenzione",
            description: "Sistemi gestionali completi con moduli personalizzati e integrazione e-commerce",
            image: "/images/odoo-erp.jpg",
            link: "/services/development/odoo",
            icon: "fas fa-cubes",
            color: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
        },
        {
            id: 2,
            title: "Magento 2 / OpenMage",
            subtitle: "Custom & Manutenzione",
            description: "E-commerce Magento 2 e OpenMage con moduli personalizzati, migrazioni e performance ottimizzate",
            image: "/images/ecommerce.jpg",
            link: "/services/development/e-commerce-solutions",
            icon: "fab fa-magento",
            color: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)"
        },
        {
            id: 3,
            title: "Centralini VoIP",
            subtitle: "Cloud & Assistenza",
            description: "Centralini Asterisk in cloud con integrazione gestionale e supporto dedicato",
            image: "/images/voip.jpg",
            link: "/services/voip/voip-asterisk",
            icon: "fas fa-phone-volume",
            color: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)"
        },
        {
            id: 4,
            title: "Cloud & Server",
            subtitle: "Gestione Linux",
            description: "Infrastrutture cloud scalabili e amministrazione server Linux professionale",
            image: "/images/cloud-server.jpg",
            link: "/services/infrastructure/server-linux",
            icon: "fas fa-server",
            color: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)"
        },
        {
            id: 5,
            title: "Proxmox VE",
            subtitle: "Virtualizzazione & Backup",
            description: "Virtualizzazione open source, Proxmox Backup Server e migrazione da VMware senza interruzioni",
            image: "/images/cloud-server.jpg",
            link: "/services/infrastructure/proxmox",
            icon: "fas fa-layer-group",
            color: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)"
        },
        {
            id: 6,
            title: "Digital Transformation",
            subtitle: "Consulenza & Automazione",
            description: "Digitalizzazione dei processi aziendali, automazione e decisioni guidate dai dati",
            image: "/images/developer.jpg",
            link: "/digital-transformation",
            icon: "fas fa-arrows-rotate",
            color: "linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)"
        }
    ];

    return (
        <section ref={sectionRef} className="featured-services-section section-padding">
            <Container>
                <Row>
                    <Col lg={8} className="mx-auto text-center mb-5">
                        <h2 className={`section-title ${inView ? 'animate-title' : ''}`}>
                            I Nostri <span className="gradient-text">Principali Servizi</span>
                        </h2>
                        <p className={`section-subtitle ${inView ? 'animate-subtitle' : ''}`}>
                            Soluzioni innovative su misura per trasformare il tuo business digitale
                        </p>
                    </Col>
                </Row>

                <Row className="featured-services-grid">
                    {services.map((service, index) => (
                        <Col lg={6} md={6} className="mb-4" key={service.id}>
                            <Card 
                                className={`featured-service-card ${inView ? 'animate-card' : ''}`}
                                style={{animationDelay: `${index * 0.2}s`}}
                            >
                                <div className="card-image-container">
                                    <div 
                                        className="card-gradient-overlay"
                                        style={{background: service.color}}
                                    ></div>
                                    <img 
                                        src={service.image} 
                                        alt={service.title}
                                        className="card-background-image"
                                    />
                                    <div className="card-content-overlay">
                                        <div className="service-icon-large">
                                            <i className={service.icon}></i>
                                        </div>
                                        <h3 className="service-card-title">{service.title}</h3>
                                        <h4 className="service-card-subtitle">{service.subtitle}</h4>
                                        <p className="service-card-description">{service.description}</p>
                                        <Link to={service.link} className="btn-featured">
                                            Vai ai Dettagli
                                            <i className="fas fa-arrow-right ml-2"></i>
                                        </Link>
                                    </div>
                                </div>
                                
                                <div className="floating-elements">
                                    <div className="floating-dot dot-1"></div>
                                    <div className="floating-dot dot-2"></div>
                                    <div className="floating-dot dot-3"></div>
                                </div>
                            </Card>
                        </Col>
                    ))}
                </Row>

                <Row className="mt-5">
                    <Col className="text-center">
                        <Link to="/services" className={`btn-gradient btn-lg ${inView ? 'animate-cta' : ''}`}>
                            <span>Esplora Tutti i Servizi</span>
                        </Link>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default FeaturedServices;